import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Cash Minus"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-cash-minus',
    templateUrl: './icon-cash-minus.component.html',
    styleUrls: ['./icon-cash-minus.component.scss'],
    standalone: false
})
export class IconCashMinusComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
